// Generate a random number between 53 and 290
function generateRandomInterest() {
	return Math.floor(Math.random() * (290 - 53 + 1)) + 53;
}

// Function to check if the random number needs to be refreshed
function getInterestNumber(productId) {
	const storedData = localStorage.getItem(`interest_count_${productId}`);
	const currentTime = new Date().getTime();
	const oneHour = 60 * 60 * 1000; // milliseconds in one hour

	if (storedData) {
		const { timestamp, randomInterest } = JSON.parse(storedData);

		// If the number is older than 1 hour, generate a new one
		if (currentTime - timestamp > oneHour) {
			const newInterest = generateRandomInterest();
			const newTimestamp = currentTime;

			// Store the new interest count and timestamp
			localStorage.setItem(`interest_count_${productId}`, JSON.stringify({ randomInterest: newInterest, timestamp: newTimestamp }));
			return newInterest;
		} else {
			return randomInterest; // Return the stored random interest if less than 1 hour old
		}
	} else {
		const randomInterest = generateRandomInterest();
		const newTimestamp = currentTime;

		// Store the random number and current time in localStorage
		localStorage.setItem(`interest_count_${productId}`, JSON.stringify({ randomInterest, timestamp: newTimestamp }));
		return randomInterest;
	}
}

// Function to update the interest count on page load and every hour
function updateInterestCounts() {
	document.querySelectorAll('.interested_feature_wrapper').forEach(function (element) {		
		const productId = element.id.replace('interest-count-', '');
		const randomInterest = getInterestNumber(productId);
		element.textContent = `${randomInterest} people are interested`;
	});
}

// Update interest counts on page load
document.addEventListener('DOMContentLoaded', function () {
	updateInterestCounts();
	
	// Set an interval to refresh interest counts every hour
	setInterval(updateInterestCounts, 60 * 60 * 1000); // every hour (in milliseconds)
});